<template>
  <div class="home-slide" >
    <div class="background rounded-3xl overflow-hidden" :style="`background: url(${img})`">
      <div class="background-overlay layout-padding">
        <div class="slide-mts mx-auto flex flex-col justify-center items-center" >
          <div class="title text-center">
            {{ title }}
          </div>
          <div class="subtitle mt-6 text-center paragraph">
            {{ subtitle }}
          </div>
          <button
            class="learn-more-btn mt-5  rounded-full"
            @click="$router.push('/about')"
          >
            <div class="flex items-center gap-2" >
             <span style="margin-left:24px;"> {{ content.learnMore }}</span>
              <img src="/static/images/arrow.svg" class="w-8 icon" />
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "subtitle", "img"],
  inject: ["content"],
};
</script>